// extracted by mini-css-extract-plugin
export var badge = "styles-module__badge___UCy0T";
export var gc = "styles-module__gc___CIm34";
export var img = "styles-module__img___BhlYv";
export var logo = "styles-module__logo___x9PIF";